// import { createStore, applyMiddleware, compose } from 'redux';
// import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage/session';

// import thunk from 'redux-thunk';

// import rootReducer from './root.reducer';
// const persistConfig = {
//   key: 'root',
//   storage,
//   whitelist: ['user'],
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// const composeEnhancers =
//   (typeof window !== 'undefined' &&
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
//   compose;

// const enhancer = composeEnhancers(
//   applyMiddleware(thunk)
//   // other store enhancers if any
// );

// const store = createStore(persistedReducer, enhancer);
// const persistor = persistStore(store);

// export default store;
// export { store, persistor };



// React Toolkit 

import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import rootReducer from './root.reducer';

// Redux Persist Config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
};

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = configureStore({

  reducer: persistedReducer,  

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: false, 
    }),
  // devTools: process.env.NODE_ENV !== 'production', 
});


const persistor = persistStore(store);

export default store;
export { store, persistor };
